import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const SITE_LOGO = '/logo.png';
const links = [
  { path: '/admin',             label: 'Dashboard',        icon: '📊', exact: true },
  { path: '/admin/users',       label: 'Users & Admins',   icon: '👥' },
  { path: '/admin/platforms',   label: 'Platforms',        icon: '🎮' },
  { path: '/admin/offers',      label: 'Offers',           icon: '🎁' },
  { path: '/admin/memberships', label: 'Memberships',      icon: '💎' },
  { path: '/admin/deposits',    label: 'Deposits',         icon: '💰' },
  { path: '/admin/payments',    label: 'Payment Methods',  icon: '💳' },
  { path: '/admin/games',       label: 'Mini Games',       icon: '🎰' },
  { path: '/admin/wheel',       label: 'Wheel of Fortune', icon: '🎡' },
  { path: '/admin/announcements', label: 'Announcements',  icon: '📢' },
  { path: '/admin/referrals',   label: 'Referrals',        icon: '👥' },
  { path: '/admin/reviews',     label: 'Reviews',          icon: '⭐' },
  { path: '/admin/chat',        label: 'Live Chat',        icon: '💬' },
  { path: '/admin/policy',      label: 'Policies',         icon: '📋' },
  { path: '/admin/about',       label: 'About Page',       icon: '📄' },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [logoError, setLogoError] = useState(false);
  const handleLogout = () => { logout(); navigate('/login'); };
  const sidebarW = sidebarOpen ? 240 : 64;

  const LogoIcon = ({ size=32 }) => !logoError
    ? <img src={SITE_LOGO} alt="Logo" onError={()=>setLogoError(true)} style={{width:size,height:size,objectFit:'contain',borderRadius:6,flexShrink:0}}/>
    : <div style={{width:size,height:size,background:'var(--gradient-primary)',borderRadius:8,display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'var(--font-display)',fontWeight:900,fontSize:size*0.45,color:'#0a0900',flexShrink:0}}>A</div>;

  return (
    <div style={{display:'flex',minHeight:'100vh',background:'var(--bg-primary)'}}>
      <div style={{width:sidebarW,background:'var(--bg-secondary)',borderRight:'1px solid var(--border)',display:'flex',flexDirection:'column',position:'fixed',top:0,left:0,bottom:0,zIndex:100,transition:'width 0.2s',overflow:'hidden'}}>
        <div style={{padding:'16px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:10,minHeight:70}}>
          <LogoIcon size={36}/>
          {sidebarOpen && <span style={{fontFamily:'var(--font-display)',fontSize:13,fontWeight:700,color:'var(--text-primary)',whiteSpace:'nowrap'}}>APEX ADMIN</span>}
        </div>
        <nav style={{flex:1,padding:'10px 8px',display:'flex',flexDirection:'column',gap:1,overflowY:'auto'}}>
          {links.map(l=>(
            <NavLink key={l.path} to={l.path} end={l.exact}
              style={({isActive})=>({
                display:'flex',alignItems:'center',gap:12,padding:'8px 12px',borderRadius:8,
                color:isActive?'#f5c400':'var(--text-secondary)',
                background:isActive?'rgba(245,196,0,0.08)':'transparent',
                fontWeight:isActive?700:500,fontSize:13,textDecoration:'none',
                whiteSpace:'nowrap',overflow:'hidden',transition:'all 0.15s',
              })}>
              <span style={{flexShrink:0,fontSize:15}}>{l.icon}</span>
              {sidebarOpen&&l.label}
            </NavLink>
          ))}
        </nav>
        <div style={{padding:'10px 8px',borderTop:'1px solid var(--border)'}}>
          <NavLink to="/" style={{display:'flex',alignItems:'center',gap:12,padding:'8px 12px',borderRadius:8,color:'var(--text-secondary)',fontSize:13,textDecoration:'none',whiteSpace:'nowrap',overflow:'hidden'}}>
            <span style={{flexShrink:0}}>🌐</span>{sidebarOpen&&'View Site'}
          </NavLink>
          <button onClick={handleLogout} style={{display:'flex',alignItems:'center',gap:12,padding:'8px 12px',borderRadius:8,color:'#ef4444',fontSize:13,background:'transparent',border:'none',cursor:'pointer',width:'100%',whiteSpace:'nowrap',overflow:'hidden'}}>
            <span style={{flexShrink:0}}>🚪</span>{sidebarOpen&&'Logout'}
          </button>
        </div>
      </div>
      <div style={{marginLeft:sidebarW,flex:1,display:'flex',flexDirection:'column',transition:'margin-left 0.2s'}}>
        <div style={{height:64,background:'var(--bg-secondary)',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'space-between',padding:'0 24px',position:'sticky',top:0,zIndex:50}}>
          <button onClick={()=>setSidebarOpen(!sidebarOpen)} style={{background:'transparent',border:'none',color:'var(--text-secondary)',fontSize:20,cursor:'pointer'}}>☰</button>
          <div style={{display:'flex',alignItems:'center',gap:12}}>
            <div style={{textAlign:'right'}}>
              <div style={{fontSize:14,fontWeight:700}}>{user?.username}</div>
              <div style={{fontSize:11,color:'var(--text-secondary)',textTransform:'uppercase',letterSpacing:'0.05em'}}>{user?.role?.replace('_',' ')}</div>
            </div>
            <div style={{width:36,height:36,borderRadius:'50%',background:'var(--gradient-primary)',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:16,color:'#0a0900'}}>{user?.username?.[0]?.toUpperCase()}</div>
          </div>
        </div>
        <div style={{flex:1,padding:'28px 24px',overflowY:'auto'}}><Outlet/></div>
      </div>
    </div>
  );
}
